import {AfterViewInit, Component, ChangeDetectionStrategy} from "@angular/core";

import {MealKitButtonComponent} from "@yoni/mealcomponents-lib";

@Component({
    selector: "login-page",
    templateUrl: "./LoginPageComponent.html",
    styleUrls: ["./LoginPageComponent.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MealKitButtonComponent]
})
export class LoginPageComponent implements AfterViewInit {


  ngAfterViewInit(): void {
  }


  ngOnInit() {
  }

  login() {

  }
}
